(function(){

    'use strict';
    angular
        .module('app.widgets')
        .directive('customDatepicker', function () {
            return {
                restrict: 'EA',
                scope:{
                    myDate: '=ngModel',
                    notRequired : '@?',
                    options : '=?',
                    name : '@'
                },
                template: require('html!./custom-datepicker.html'),
                link : function (scope, element, attrs, ngModelCtrl) {
                    if(scope.myDate && typeof scope.myDate == 'moment'){
                        scope.myDate = scope.myDate.toDate();
                    }
                    scope.notRequired = scope.notRequired ? false : true;
                    scope.open = function($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        scope.opened = true;
                    };

                    scope.datepickerOptions = angular.extend({},{'show-button-bar': false, 'show-weeks':false}, scope.options);
                }
            };
        });
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/customDatepicker/custom-datepicker.js
 ** module id = 173
 ** module chunks = 0
 **/